import React from "react";
import { useEffect,useState } from "react";

const Dashboard = () => {
  const [user, setUser] = useState("");
  useEffect(() => {
    // Retrieve user details from local storage
    const userData = localStorage.getItem("user");
    
    if (userData) {
      setUser(JSON.parse(userData));
    }
  }, []);


  return (
    <div>
      <h1>
        Welcome To {user.name} Admin Panel
      </h1>
    </div>
  );
};

export default Dashboard;
